import { render, staticRenderFns } from "./SettingsMaterial.vue?vue&type=template&id=d83c11b8&scoped=true&"
import script from "./SettingsMaterial.vue?vue&type=script&lang=js&"
export * from "./SettingsMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMaterial.vue?vue&type=style&index=0&id=d83c11b8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83c11b8",
  null
  
)

export default component.exports